import script from "./WebSocketReader.vue?vue&type=script&lang=js"
export * from "./WebSocketReader.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__